import { Injectable } from "@angular/core"
import { AppConfiguration } from "./app.configuration.types"

// tslint:disable-next-line: no-empty-interface
export interface AppConfig extends AppConfiguration {}

@Injectable()
export abstract class AppConfig implements AppConfiguration {}
